(function () {
  if (!document.body.classList.contains('currency-sar')) return;

  var BAD_CHARS = /[\u20C1\uE900\uFDFC\uFFFD]/g;
  var PRICE_SELECTOR =
    '.hdt-money, .money, shopify-money, .pj-cbundle__price, .pj-cbundle__summary-total, ' +
    '.raazz-hp-product__price-current, .raazz-hp-product__price-compare, ' +
    '.raazz-col-card__price-current, .raazz-col-card__price-compare, .raazz-pcc__price-value, ' +
    '.hdt-sticky-atc__product-monney, .hdt-price-save-badge, .raazz-product-card__price-current, ' +
    '.raazz-product-card__price-compare';

  var GLYPH_PATHS =
    '<path d="M699.62,1113.02h0c-20.06,44.48-33.32,92.75-38.4,143.37l424.51-90.24c20.06-44.47,33.31-92.75,38.4-143.37l-424.51,90.24Z"/>' +
    '<path d="M1085.73,895.8c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.33v-135.2l292.27-62.11c20.06-44.47,33.32-92.75,38.4-143.37l-330.68,70.27V66.13c-50.67,28.45-95.67,66.32-132.25,110.99v403.35l-132.25,28.11V0c-50.67,28.44-95.67,66.32-132.25,110.99v525.69l-295.91,62.88c-20.06,44.47-33.33,92.75-38.42,143.37l334.33-71.05v170.26l-358.3,76.14c-20.06,44.47-33.32,92.75-38.4,143.37l375.04-79.7c30.53-6.35,56.77-24.4,73.83-49.24l68.78-101.97v-.02c7.14-10.55,11.3-23.27,11.3-36.97v-149.98l132.25-28.11v270.4l424.53-90.28Z"/>';

  function isBold(el) {
    var node = el;
    while (node && node !== document.body) {
      var fw = window.getComputedStyle(node).fontWeight;
      if (fw === 'bold' || parseInt(fw, 10) >= 600) return true;
      if (
        node.classList &&
        (node.classList.contains('hdt-price') ||
          node.classList.contains('raazz-hp-product__price-current') ||
          node.classList.contains('raazz-col-card__price-current') ||
          node.classList.contains('raazz-product-card__price-current'))
      ) {
        return true;
      }
      node = node.parentElement;
    }
    return false;
  }

  function createGlyph(bold) {
    var tpl = document.getElementById('raazz-sar-glyph-tpl');
    if (tpl && tpl.content && tpl.content.firstElementChild) {
      var clone = tpl.content.firstElementChild.cloneNode(true);
      if (bold) clone.classList.add('raazz-sar-glyph--bold');
      return clone;
    }

    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', 'raazz-sar-glyph' + (bold ? ' raazz-sar-glyph--bold' : ''));
    svg.setAttribute('viewBox', '0 0 1124.14 1256.39');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.innerHTML = GLYPH_PATHS;
    return svg;
  }

  function buildPrice(text, bold) {
    var wrap = document.createElement('span');
    wrap.className = 'raazz-sar-money';
    var amount = document.createElement('span');
    amount.className = 'raazz-sar-amount';
    amount.textContent = text;
    wrap.appendChild(amount);
    wrap.appendChild(createGlyph(bold));
    return wrap;
  }

  function normalizeElement(el) {
    if (!el || el.closest('.raazz-sar-money')) return;

    var text = (el.textContent || '').replace(BAD_CHARS, '').replace(/\s+/g, ' ').trim();
    if (!text || !/\d/.test(text)) return;

    var replacement = buildPrice(text, isBold(el));
    if (el.classList.contains('hdt-money')) {
      replacement.classList.add('hdt-money');
    }
    // Preserve styling classes on wrapper elements (e.g. the savings badge) so
    // their background/padding/shape survives the rewrap.
    if (el.classList.contains('hdt-price-save-badge')) {
      replacement.classList.add('hdt-price-save-badge');
    }
    el.replaceWith(replacement);
  }

  function run(root) {
    root.querySelectorAll(PRICE_SELECTOR).forEach(function (el) {
      if (!el.closest('.raazz-sar-money')) {
        normalizeElement(el);
      }
    });
  }

  function boot() {
    run(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('currency:update', boot);

  new MutationObserver(function () {
    run(document);
  }).observe(document.body, { childList: true, subtree: true, characterData: true });
})();
